import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]
  static values = {
    show: Array,
    source: { type: String, default: "#membership_role_id" }
  }

  connect() {
    this.sourceElement = document.querySelector(this.sourceValue)
    if (this.sourceElement) {
      this.sourceElement.addEventListener("change", this.toggle.bind(this))
      this.toggle()
    }
  }

  disconnect() {
    if (this.sourceElement) {
      this.sourceElement.removeEventListener("change", this.toggle.bind(this))
    }
  }

  toggle() {
    const selectedValue = this.sourceElement.value
    const shouldShow = this.showValue.map(String).includes(selectedValue)

    if (shouldShow) {
      this.element.classList.remove("hidden")
      if (this.hasFieldTarget) {
        this.fieldTarget.required = true
      }
    } else {
      this.element.classList.add("hidden")
      if (this.hasFieldTarget) {
        this.fieldTarget.required = false
      }
    }
  }
}
